import { FieldValues, Path, PathValue, useFormContext, useWatch } from "react-hook-form";

import { Flex } from "#shared/view/components/Flex";
import { RecommendButton } from "#shared/view/designSystem/inputs/RecommendButton";
import { round } from "shared";

export type RecommendedButtonGroupProps<T extends FieldValues> = {
  name: Path<T>;
  computedValue: { value: PathValue<T, Path<T>> | null; message?: string } | undefined;
  companyValue: { value: PathValue<T, Path<T>> | null; message?: string } | undefined;

  precision: number | undefined;
};

export const RecommendButtonGroup = <T extends FieldValues>({
  name,
  companyValue,
  computedValue,
  precision,
}: RecommendedButtonGroupProps<T>) => {
  const { setValue, control } = useFormContext<T>();

  const setComputedValue = () => {
    if (computedValue && computedValue.value !== null) {
      setValue(name, computedValue.value, {
        shouldTouch: false,
      });
    }
  };

  const setCompanyValue = () => {
    if (companyValue && companyValue.value !== null) {
      setValue(name, companyValue.value, {
        shouldTouch: false,
      });
    }
  };

  const hasComputedValue = !!computedValue;
  const hasCompanyValue = !!companyValue;
  const currentValue = useWatch({ control, name });

  return (
    <Flex gap={0}>
      {hasComputedValue && (
        <RecommendButton
          iconName="recommend"
          onClick={setComputedValue}
          active={
            !!computedValue.value &&
            round(currentValue, precision) === round(computedValue.value, precision)
          }
          disabled={computedValue.value === null}
          tooltip={computedValue.message}
        />
      )}
      {hasCompanyValue && (
        <RecommendButton
          iconName="factory"
          onClick={setCompanyValue}
          active={
            !!companyValue.value &&
            round(currentValue, precision) === round(companyValue.value, precision)
          }
          disabled={companyValue.value === null}
          tooltip={companyValue.message}
        />
      )}
    </Flex>
  );
};
